import { TextView } from "@components";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ShareIcon from "assets/images/share-icon-bg.svg";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ASSETS, PATH } from "../../utils/config";

const disableColor = "rgba(187, 187, 187, 1)";

const ViewWheelHeader = ({
  authorName = "",
  disable = false,
  authorImage = "", //Not available in API
  onFollowClick = () => {},
  wheelName = "",
  showSegmentInfo = false,
  setshowSegmentInfo = () => {},
  onHeartClick = () => {},
  onCloneClick = () => {},
  handleShare = () => {},
  onInfoClick = () => {},
  onWheelClick = () => {},
  isMyProfile = false,
  wheelId,
  isLoading = false,
  user_id = "",
}) => {


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    handleShare(false);
  };

  const clickInfoButton = () => {
    if (!disable) {
      setshowSegmentInfo(true);
      onInfoClick && onInfoClick();
    }
  };

  const clickWheelButton = () => {
    if (!disable) {
      setshowSegmentInfo(false);
      onWheelClick && onWheelClick();
    }
  };

  let nav = useNavigate();

  const onEditClick = () => {
    nav(`/EditCustomWheel/${wheelId}/null`);
  };

  const renderLeftItem = () => {
    return (
      <Grid
        xs={4}
        alignSelf={"center"}
        justifyContent={"left"}
        display={"flex"}
        alignItems={"center"}
        paddingLeft={2}
      >
        {isMyProfile ? (
          <>
            <img
              onClick={() => nav(PATH.DASHBOARD)}
              src={
                authorImage
                  ? authorImage
                  : "https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
              }
              alt="author"
              style={{
                height: "42px",
                width: "42px",
                borderRadius: "21px",
                cursor: "pointer",
              }}
            />
            <Typography
              onClick={() => nav(PATH.DASHBOARD)}
              sx={{
                fontFamily: "DM Sans",
                fontSize: 12,
                lineHeight: "20px",
                color: "#123051",
                marginLeft: "12px",
                cursor: "pointer",
              }}
            >
              {authorName ? authorName : "Wheel Author"}
            </Typography>
          </>
        ) : (
          <>
            <ChevronLeftIcon
              onClick={() => nav(PATH.DASHBOARD)}
              style={{
                color: "#123051",
                marginLeft: "10px",
                // marginTop: "-2px",
                cursor: "pointer",
              }}
            />
            <TextView
              variant="text"
              onClick={() => nav(PATH.DASHBOARD)}
              style={{
                // color: colors.white,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "DM Sans",
                fontSize: "13px",
                lineHeight: "20px",
              }}
            >
              Back to my Gallery
            </TextView>
          </>
        )}
        {/* <img
          src={ASSETS.messageIcon}
          alt="message"
          style={{
            height: "22px",
            width: "22px",
            marginLeft: "12px",
            cursor: "pointer",
          }}
        /> */}
        {/* <Button
          sx={{
            height: "22px",
            borderRadius: "20px",
            backgroundColor: "#F6F7F9",
            border: "0.5px solid #E1E1E1",
            color: "#123051",
            fontFamily: "DM Sans",
            fontSize: 12,
            marginLeft: "15px",
            cursor: "pointer",
            fontWeight: "500",
            pl: 2,
            pr: 2,
            textTransform: "capitalize",
          }}
        >
          Follows
        </Button> */}
      </Grid>
    );
  };

  const renderCenterItem = () => {
    return (
      <Grid
        xs={4}
        alignSelf={"center"}
        justifyContent={"center"}
        display={"flex"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            fontFamily: "DM Sans",
            fontSize: 16,
            lineHeight: "20px",
            color: "#123051",
            fontWeight: "700",
            mr: 1.5,
          }}
        >
          {wheelName ? wheelName : "Wheel Name"}
        </Typography>
        {isMyProfile ? null : (
          <>
            <img
              onClick={onCloneClick}
              src={ASSETS.cloneDark}
              alt="clone"
              style={{
                height: "25px",
                width: "25px",
                marginLeft: "5px",
                cursor: "pointer",
              }}
            />
          </>
        )}
      </Grid>
    );
  };

  const renderRightItem = () => {
    return (
      <Grid
        xs={4}
        alignSelf={"center"}
        justifyContent={"right"}
        display={"flex"}
        alignItems={"center"}
      >
        <img
          onClick={()=>handleShare(true)}
          src={ShareIcon}
          alt="message"
          style={{
            marginRight: "10px",
            cursor: "pointer",
          }}
        />
        {/* {isMyProfile ? (
          <>
            <Stack
              justifyContent={"center"}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              onClick={onEditClick}
              sx={{
                backgroundColor: "#F6F7F9",
                p: 0.3,
                borderRadius: "4px",
                height: "40px",
                marginRight: "10px",
                paddingLeft: 2.5,
                paddingRight: 2.5,
                cursor: "pointer",
              }}
            >
              <img
                onClick={onEditClick}
                src={ASSETS.pencilEditIcon}
                alt="message"
                style={{
                  height: "18px",
                  width: "18px",
                  marginRight: "5px",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: "500",
                  color: "#123051",
                  fontSize: "12px",
                }}
              >
                Go to Edit Mode
              </Typography>
            </Stack>
          </>
        ) : null} */}
        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          sx={{
            border: "0.5px solid #BBBBBB",
            backgroundColor: "#F6F7F9",
            p: 0.3,
            borderRadius: "4px",
            height: "40px",
          }}
        >
          <Box
            onClick={clickInfoButton}
            sx={{
              backgroundColor: showSegmentInfo ? "#123051" : "#F6F7F9",
              height: "32px",
              cursor: "pointer",

              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              onClick={clickInfoButton}
              sx={{
                fontFamily: "DM Sans",
                cursor: "pointer",
                fontWeight: "500",
                pl: 2,
                pr: 2,
                textTransform: "capitalize",
                color: showSegmentInfo ? "white" : "#BBBBBB",
              }}
            >
              Wheel
            </Typography>
          </Box>
          <Box
            onClick={clickWheelButton}
            sx={{
              backgroundColor: disable
                ? disableColor
                : !showSegmentInfo
                ? "#123051"
                : "#F6F7F9",
              height: "32px",
              cursor: "pointer",

              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              onClick={clickWheelButton}
              sx={{
                fontFamily: "DM Sans",
                cursor: "pointer",
                fontWeight: "500",
                px: 3,
                textTransform: "capitalize",
                color: !showSegmentInfo ? "white" : "#BBBBBB",
              }}
            >
              Info
            </Typography>
          </Box>
        </Stack>
      </Grid>
    );
  };
  //HEADER UI
  return (
    <Grid
      container
      spacing={2}
      sx={{
        py: 1,
        px: 2,
        backgroundColor: "white",
        marginTop: 0,
        position:'relative'
      }}
    >
      {isLoading ? (
        <div style={{ height: "60px" }}></div>
      ) : (
        <>
          {renderLeftItem()}
          {renderCenterItem()}
          {renderRightItem()}
        </>
      )}
    </Grid>
  );
};

export default ViewWheelHeader;
